import { ActivatedRouteSnapshot, Route } from '@angular/router';
import { inject } from '@angular/core';
import { SolutionCategoryService } from '@app/src/app/modules/solution/service/solution.category.service';
import { SolutionService } from '@app/src/app/modules/solution/service/solution.service';
import { SolutionCategoryGuard } from '@app/src/app/modules/solution/classes/category/guard/solution-category-guard';
import { SolutionGuard } from '@app/src/app/modules/solution/classes/default/guard/solution-guard';

export default {
  path: 'solutions',
  data: {
    titlePrefix: 'Solutions',
  },
  children: [
    {
      path: ':category',
      children: [
        {
          path: '',
          loadComponent: () =>
            import('@app/src/app/modules/solution/views/public/category/category-solutions-list/category-solutions-list').then(
              (m) => m.CategorySolutionsList,
            ),
          resolve: {
            item: (route: ActivatedRouteSnapshot) =>
              Promise.resolve(
                inject(SolutionCategoryService).fetchBySlug(
                  route.paramMap.get('category'),
                ),
              ),
          },
          canActivate: [SolutionCategoryGuard()],
        },
        {
          path: ':solution',
          loadComponent: () =>
            import('@app/src/app/modules/solution/views/public/default/solution-item/solution-item').then(
              (m) => m.SolutionItem,
            ),
          resolve: {
            item: (route: ActivatedRouteSnapshot) =>
              inject(SolutionService).fetchBySlug(
                route.paramMap.get('solution'),
                route.paramMap.get('category'),
              ),
          },
          canActivate: [SolutionGuard()],
        },
      ],
    },
  ],
} as Route;
